import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  Title:string;
  Message:string;
  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any) { 
this.Title = "Confirmation";
this.Message= "Are You Sure";

    }

    
  ngOnInit(): void {
    this.BindData();
  }

  BindData() {
    if (this.data) {
      if( this.data.Title != undefined)
          this.Title = this.data.Title;
      if (this.data.Message != undefined)
          this.Message = this.data.Message;     
    }

  }

 

  public decline() {
    this.dialogRef.close({ event: 'decline', data: {"IsConfirmed":false} });
  }

  public accept() {
    this.dialogRef.close({ event: 'accept', data: {"IsConfirmed":true} });
  }

  public dismiss() {
    this.dialogRef.close({ event: 'dismiss', data: {"IsConfirmed":false} });
  }


}
